module.exports = __webpack_public_path__ + "static/media/2020.4.23社会服务中心助力旧衣改造活动.3febb0e7.jpg";